import { ModeOfTransport } from "@iventis/domain-model/model/modeOfTransport";
import { FixedShape } from "@iventis/domain-model/model/fixedShape";
import { MetricName } from "@iventis/domain-model/model/metricName";
import { incrementMonitoringCount } from "../set-monitoring-metric";
import { MetricEvent } from "../metric-types";

export function drawMapObjectMetric(mapObjectProperties: { fixedShape?: FixedShape; modeOfTransport?: ModeOfTransport }, event: Partial<MetricEvent> = {}) {
    if (mapObjectProperties.fixedShape != null) {
        incrementMonitoringCount({ ...event, name: MetricName.FIXED_SHAPE_MAP_OBJECT_USED });
    } else if (mapObjectProperties.modeOfTransport != null) {
        incrementMonitoringCount({ ...event, name: MetricName.ROUTE_MAP_OBJECT_USED });
    } else {
        incrementMonitoringCount({ ...event, name: MetricName.DRAW_MAP_OBJECT_USED });
    }
}
